import { EmployeeService } from "~/entity/Employee/api/service";

export const useEmployee = () => {
  const getStatistics = EmployeeService.GET.getStatistics;
  const getDealerLevelReport = EmployeeService.GET.getDealerLevelReport;
  const getCourseByExpectation = EmployeeService.GET.getCourseByExpectation;
  const getEmployeeCoursesRequired =
    EmployeeService.GET.getEmployeeCoursesRequired;
  const getCoursesByExpectation = EmployeeService.GET.getCoursesByExpectation;
  const getStatisticsCoursesReport =
    EmployeeService.GET.getStatisticsCoursesReport;
  const getEducationPrograms = EmployeeService.GET.getEducationPrograms;
  const getEducationProgramsById = EmployeeService.GET.getEducationProgramsById;
  const card = EmployeeService.GET.card;
  const list = EmployeeService.GET.list;

  const getStatisticsCoursesReportFileHash =
    EmployeeService.POST.getStatisticsCoursesReportFileHash;
  const getCourseByExpectationFileHash =
    EmployeeService.POST.getCourseByExpectationFileHash;
  const getCoursesByExpectationFileHash =
    EmployeeService.POST.getCoursesByExpectationFileHash;
  const getEmployeeCoursesRequiredFileHash =
    EmployeeService.POST.getEmployeeCoursesRequiredFileHash;
  const setEducationPrograms = EmployeeService.POST.setEducationPrograms;
  const uploadEmployeeDocument = EmployeeService.POST.uploadEmployeeDocument;
  const create = EmployeeService.POST.create;

  const updateEducationProgram = EmployeeService.PUT.updateEducationProgram;
  const updateCard = EmployeeService.PUT.updateCard;

  const fireCard = EmployeeService.DELETE.fireCard;

  return {
    // GET
    getStatistics,
    getDealerLevelReport,
    getCourseByExpectation,
    getStatisticsCoursesReport,
    getCoursesByExpectation,
    getEmployeeCoursesRequired,
    getEducationPrograms,
    getEducationProgramsById,
    card,
    list,

    // POST
    getCoursesByExpectationFileHash,
    getStatisticsCoursesReportFileHash,
    getCourseByExpectationFileHash,
    getEmployeeCoursesRequiredFileHash,
    setEducationPrograms,
    uploadEmployeeDocument,
    create,

    // PUT
    updateEducationProgram,
    updateCard,

    // DELETE
    fireCard,
  };
};
